<template>
<div id="room-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="room-modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="room-modalLabel">{{ kosiwon_name }} / {{ roomStatus.headText }}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body p-3">
                <form autocomplete="off">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="mb-4">
                                <label class="form-label">방 호실 <span class="text-danger">*</span></label>
                                <input class="form-control" type="text" id="name" placeholder="방 호실을 입력해주세요." v-model="room.name" />
                                <label class="font-13 text-muted fw-light mt-1">e.g "101호"</label>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="mb-4">
                                <label class="form-label">방 크기</label>
                                <div class="input-group">
                                    <input class="form-control" type="number" id="room_size" placeholder="방 크기를 입력해주세요." min="0" v-model="room.room_size" />
                                    <span class="input-group-text">㎡</span>
                                </div>
                                <label class="font-13 text-muted fw-light mt-1">e.g "10㎡", 숫자만 입력해주세요.</label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="mb-4">
                                <label class="form-label">월 임대료 <span class="text-danger">*</span></label>
                                <div class="input-group">
                                    <input class="form-control" type="number" id="price" placeholder="월 임대료를 입력해주세요." min="0" max="1000" v-model.number="room.price" />
                                    <span class="input-group-text">만원</span>
                                </div>
                                <label class="font-13 text-muted fw-light mt-1">e.g "숫자만 입력, 천원 단위는 소수 첫째자리까지 입력"</label>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="mb-4">
                                <label class="form-label">월 관리비 <span class="text-danger">*</span></label>
                                <div class="input-group">
                                    <input class="form-control" type="number" id="maintenance_price" placeholder="월 관리비를 입력해주세요." min="0" max="1000" v-model.number="room.maintenance_price" />
                                    <span class="input-group-text">만원</span>
                                </div>
                                <label class="font-13 text-muted fw-light mt-1">e.g "관리비 없을 시, 0 입력"</label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="mb-4">
                                <div class="d-flex align-items-center" style="margin-bottom: 0.5rem;">
                                    <label class="form-label mb-0">보증금 <span class="text-danger">*</span></label>
                                    <div class="form-check ms-auto">
                                        <label class="form-check-label" for="depositChk">고시원 보증금으로 설정</label>
                                        <input type="checkbox" class="form-check-input" id="depositChk" v-model="checked" @change="changeCheck()">
                                    </div>
                                </div>
                                <div class="input-group">
                                    <input class="form-control" type="number" id="deposit" placeholder="보증금을 입력해주세요." min="0" max="1000" v-model.number="room.deposit" :disabled="checked" />
                                    <span class="input-group-text">만원</span>
                                </div>
                                <label class="font-13 text-muted fw-light mt-1">e.g "보증금 없을 시, 0 입력"</label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="mb-4">
                            <label class="form-label">방 옵션 (다중 선택 가능) <span class="text-danger">*</span></label>
                            <div class="d-flex flex-wrap gap-2">
                                <button type="button" class="btn btn-outline-info" v-for="(type, idx) in options" :key="`options_${idx}`" :class="{'custom-btn-5' : isWideScreen, 'active' : type.checked}" @click="type.checked=!type.checked">
                                    {{ type.text }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="mb-4">
                                <label class="form-label">방 타입 <span class="text-danger">*</span></label>
                                <div class="d-flex flex-wrap gap-2">
                                    <button type="button" class="btn btn-outline-info" v-for="(type, idx) in roomType_options" :key="`roomType_${idx}`" :class="{'custom-btn-4' : isWideScreen, 'active' : type.checked}" @click="changeType(type, 'roomType_options')">
                                        {{ type.text }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="mb-4">
                                <label class="form-label">사용자 구분 <span class="text-danger">*</span></label>
                                <div class="d-flex flex-wrap gap-2">
                                    <button type="button" class="btn btn-outline-info" v-for="(type, idx) in sexType_options" :key="`sex_${idx}`" :class="{'custom-btn-3' : isWideScreen, 'active' : type.checked}" @click="changeType(type, 'sexType_options')">
                                        {{ type.text }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-lg-6">
                            <div class="mb-4">
                                <label class="form-label">창문 타입 <span class="text-danger">*</span></label>
                                <div class="d-flex flex-wrap gap-2">
                                    <button type="button" class="btn btn-outline-info" v-for="(type, idx) in windowType_options" :key="`window_${idx}`" :class="{'custom-btn-4' : isWideScreen, 'active' : type.checked}" @click="changeType(type, 'windowType_options')">
                                        {{ type.text }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div>
                            <label class="form-label">방 사진 정보 (10장 이내)
                                &nbsp;<i class="mdi mdi-swap-horizontal"></i>
                            </label>
                            <input class="form-control" type="file" id="roomImg" multiple @change="selectImage($event, null)">
                        </div>
                    </div>
                    <draggable class="row mb-3" v-model="room.images" v-if="room.images.length > 0" :animation="500" easing="cubic-bezier">
                        <div class="col-md-3 col-6 text-center mb-2" v-for="(item, idx) in room.images" :key="`room_image_${idx}`">
                            <div class="image-container">
                                <i class="mdi mdi-swap-horizontal room-info-img-swap"></i>
                                <img :src="item.image_url" class="img-fluid room-info-img" alt="Room Image" />
                                <div class="button-group">
                                    <input type="file" :id="`roomImg_${idx}`" accept="image/*" style="display:none;" @change="selectImage($event, idx)" />
                                    <button type="button" class="btn btn-primary btn-sm btn-sm-custom" @click="openUpload(`roomImg_${idx}`)">수정</button>
                                    <button type="button" class="btn btn-danger btn-sm btn-sm-custom" @click="deleteImage(idx)">삭제</button>
                                </div>
                            </div>
                        </div>
                    </draggable>
                    <div class="row mb-2" v-else></div>

                    <div class="row">
                        <div class="row-4">
                            <label class="form-label">메모</label>
                            <textarea class="form-control" id="memo" rows="5" placeholder="해당 호실의 특이사항, 하자보수 내역 등을 자유롭게 입력하세요." v-model="room.memo"></textarea>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer" style="justify-content: center; border-top: none;">
                <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                    닫기
                </button>
                <button type="button" class="btn btn-primary my-2" @click="$emit('save-room')">
                    {{ roomStatus.btnText }}
                </button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import common from "@/mixins/common.js";
import draggable from "vuedraggable";

export default {
    components: {
        draggable
    },
    props: ["kosiwon_name", "kosiwon_deposit", "room", "options", "sexType_options", "windowType_options", "roomType_options", "roomStatus", "isWideScreen"],
    mixins: [
        common
    ],
    data() {
        return {
            checked: true
        }
    },
    watch: {
        room() {
            this.$nextTick(() => {
                if (this.room.hasOwnProperty("created")) {
                    this.checked = false;
                } else {
                    this.checked = true;
                    this.room.deposit = this.kosiwon_deposit;
                }

                // * 옵션 값 셋팅
                this.options.forEach(option => option.checked = this.room.options[option.value]);

                // * 사용자 구분 값 셋팅
                this.sexType_options.forEach(option => option.checked = (option.value === this.room.sex_type));

                // * 창문 타입 셋팅
                this.windowType_options.forEach(option => option.checked = (option.value === this.room.window_type));

                // * 룸 타입 셋팅
                this.roomType_options.forEach(option => option.checked = (option.value === this.room.room_type));
            });
        },
        /* "watch와 this"
        watch 옵션에서 화살표 함수를 사용하면 this는 Vue 인스턴스를 가리키지 않을 수 있습니다. 
        이는 watch 옵션이 Vue 인스턴스의 메서드가 아니라 단순한 자바스크립트 객체로 정의되기 때문입니다. 따라서 화살표 함수를 사용할 때 this는 상위 스코프를 참조하게 됩니다.
        
        - watch에서의 일반 함수 사용
        watch 옵션에서는 일반 함수를 사용하여 this가 Vue 인스턴스를 참조하도록 해야 합니다. */
        "room.price": function (val) {
            this.checkNumber(val, 1000, "price", "월 임대료");
        },
        "room.maintenance_price": function (val) {
            this.checkNumber(val, 1000, "maintenance_price", "월 관리비");
        },
        "room.deposit": function (val) {
            this.checkNumber(val, 10000, "deposit", "보증금");
        }
    },
    methods: {
        changeCheck() {
            this.room.deposit = this.checked ? this.kosiwon_deposit : 0;
        },
        checkNumber(val, max, target, text) {
            if (val < 0 || val > max) {
                alert(`${text}의 값은 0만원~${max}만원 사이어야 합니다.`)
                this.room[target] = 0;
            }
        },
        changeType(type, target) {
            this[target].forEach(option => {
                option.checked = option.value === type.value;
            });
        },
        openUpload(id) {
            document.getElementById(id).click();
        },
        async selectImage(event, idx) {

            const files = event.target.files;
            const sendData = new FormData();

            if (!files || files.length === 0) {
                return;
            }

            const totalCnt = files.length + this.room.images.length; // 현재 파일 사진 수 + 이미 업로드 된 사진 수

            // 사진 수 10장 제한 (단일 이미지 및 썸네일 이미지 수정일 경우에는 제외)
            if (totalCnt > 10) {
                alert("방 사진은 최대 10장까지 사진 첨부가 가능합니다.");
                return;
            }

            for (let i = 0; i < files.length; i++) {
                if (!files[i].type.includes("image")) {
                    alert("방 사진은 이미지 파일만 등록 가능합니다.");
                    return;
                }
                sendData.append("filedata", files[i]);
            }

            try {
                this.loadingOverlay(true);

                const result = await this.axios.post("/upload/tempUploadOriginal", sendData);

                if (idx !== null) {
                    this.room.images[idx].image_url = result.data[0];
                } else {
                    result.data.forEach(url => {
                        this.room.images.push({
                            image_url: url
                        });
                    });
                }
            } catch (error) {
                console.log(error);
                alert("이미지 업로드 중 예기치 못한 에러가 발생하였습니다.\n다시 시도해주세요.");
            } finally {
                this.loadingOverlay(false);
            }
        },
        deleteImage(idx) {
            if (confirm("해당 이미지를 삭제하시겠습니까?")) {
                this.room.images.splice(idx, 1);
            }
        }
    }
}
</script>

<style>
#room-modal table,
#room-modal img {
    width: 100% !important;
}

.custom-btn-5 {
    width: calc(100%/5 - 10px);
}

.custom-btn-4 {
    width: calc(100%/4 - 10px);
}

.custom-btn-3 {
    width: calc(100%/3 - 10px);
}

.btn-sm-custom {
    --ct-btn-padding-y: 0.2rem;
    --ct-btn-padding-x: 0.2rem;
    --ct-btn-font-size: 0.8rem;
    opacity: 0.8;
}

.btn-sm-custom:hover {
    opacity: 1;
}

.image-container {
    position: relative;
    display: inline-block;
}

.button-group {
    position: absolute;
    top: 10px;
    right: 10px;
}

.button-group button {
    margin-left: 5px;
}

.room-info-img {
    max-height: 150px;
    border: 1px solid lightgray;
}

.room-info-img-swap {
    position: absolute;
    top: 10px;
    left: 10px;
    font-size: 20px;
    color: gray;
}
</style>
